<template>
  <Modal title="学生评价补充" v-model="visible">
    <Form ref="recordForm" class="feedback form"
          :label-width="90">
      <Row>
        <Col :span="22">
        <Form-item label="投诉补充">
          <label>{{ reason }}</label>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">关闭</Button>
    </div>
  </Modal>
</template>
<style>
  .feedback .ivu-form-item {
    margin-bottom: 5px
  }
</style>
<script>
  export default {
    name: 'OtherReasonModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      otherReason: {
        type: String
      },
    },
    data () {
      return {
        visible: this.value,
        reason: '',
      }
    },
    methods: {
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.$emit('input', val)
      },
      otherReason (val) {
        this.reason = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OtherReasonModal.vue?106b4772